import React from "react";
import ReactDOM from "react-dom";
import NotificationCard from "../../app/components/notifications/NotificationCard";
import { redirect } from "../../app/routes/Routes";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { findAlerts } from "../../infrastructure/repository/alerts-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

function renderNotificationCard(alert) {
  const alertAction = {
    "fund-confirmation-required": translate("alert-section.show-fund"),
    "fund-insufficient-balance": translate("alert-section.show-fund"),
    "mass-edit-session-employees-uploaded": translate(
      "alert-section.show-edit-employees"
    ),
  };

  const alertPath = {
    "fund-confirmation-required": `${alert.resolutionPath}?fromNotification=${alert.id}`,
    "fund-insufficient-balance": `${alert.resolutionPath}?fromNotification=${alert.id}`,
    "mass-edit-session-employees-uploaded": `${alert.resolutionPath}`,
  };

  const target = document.getElementById("notification-card");
  if (target) {
    ReactDOM.render(
      <NotificationCard
        handlerClick={() => redirect(alertPath[alert.category])}
        actionText={alertAction[alert.category]}
      >
        <p>{translate(`alert-section.${alert.category}`)}</p>
      </NotificationCard>,
      target
    );
  }
}

export async function displayNotificationCard() {
  try {
    const companyId = await findCompanyId();
    const { data: alerts } = await findAlerts(companyId);

    if (alerts.length > 0) {
      renderNotificationCard(alerts[0]);
    }

    addContextLog("info", "displayNotificationCard", "display-screen", {
      companyId,
    });
  } catch (e) {
    const companyId = await findCompanyId();
    logError(e, `Error to displayNotificationCard for ${companyId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
